import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 120px 0 0 0;
  min-height: 100vh;
  &.listCardBoxReserves {
    max-height: 300px;
  }
  .listCard {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin: 0 auto 1rem;
    height: 70vh;
    > div {
      height: 100%;
    }
    h3 {
      text-align: center;
    }
  }
  .products,
  .services {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 95%;
  }
  .addButton {
    
  }
  .endPage {
    display: flex;
    align-items: center;
    width: 100vw;
    margin: 0;
    padding-bottom: 1rem;
    @media (min-width: 375px) {
      width: 100%;
      justify-content: space-between
    }
  }
  .checkout {
    width: 180px;
    margin: 0 0 0 1rem;
    @media (min-width: 700px) {
      height: 50px;
    }
  }
  .total {
    background-color: var(--secondary-color);
    color: var(--details-color);
    border-radius: 8px 8px 80px 8px;
    width: 110px;
    font-size: 2rem;
    @media (min-width: 425px) {
      width: 150px;
    }
    @media (min-width: 700px) {
      height: 50px;
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .Contentmaintenance {
    text-align: center;
  }
  .maintenance {
    color: var(--details-color);
    font-size: 2rem;
    font-weight: bolder;
  }
  .maintenanceImage {
    width: 300px;
    height: 300px;
  }
  .contentAvailable {
    text-align: center;
    .checkin {
      margin: 0 auto;
    }
  }
  @media (min-width: 768px) {
    display: flex;
    padding-top: 150px;
  }
`;

export const CardInfs = styled.article`
  background-color: var(--secondary-color);
  border-radius: 8px 8px 80px 8px;
  position: relative;
  padding: 0.5rem 1rem 1rem;
  h2 {
    color: var(--details-color);
    font-size: 1.4rem;
    font-weight: bolder;
  }
  li {
    margin: 0.5rem 0;
    color: var(--primary-color);
    font-size: 1.2rem;
  }
  button {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
  }
`;

export const ContainerReserves = styled.div`
  border: 2px solid var(--secondary-color);
  margin-top: 1rem;
  height: 400px;
  display: flex;
  flex-direction: column;
  /* flex-wrap: wrap; */
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  button {
    margin: 0 auto;
  }
`;
export const ContainerReservesIntra = styled.div`
  height: 60%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  text-align: center;
  button {
    margin: 0 auto;
  }
`;
export const ContainerReservesHeader = styled.div``;
export const Reserves = styled.h3`
  font-size: 2rem;
`;
export const SpecificReserveData = styled.div``;

export const ContainerOccupied = styled.section`
  height: 100%;
  width: 100%;
`;
export const ContainerMaintenance = styled.section`
  height: 100%;
`;
export const ContainerAvailable = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;
export const ContainerButtonsAvaliable = styled.section`
  display: flex;
  button {
    &#checkin {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  }
`;
export const Status = styled.p`
  font-size: 2rem;
`;
export const Price = styled.p`
  font-size: 1.5rem;

  font-weight: bold;
`;
export const ProductsAndServicesContainer = styled.section`
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid var(--secondary-color);
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media (min-width: 1024px) {
    width: 45%;
  }
`;

export const ProdsAndServicesHeader = styled.div`
width: 100%;
margin: 5px;

display: flex;
align-items: center;
flex-flow: column nowrap;
@media (min-width: 1025px) {
  flex-flow: row nowrap;
  justify-content: space-around;
}


`
export const ContainerFather = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const Title = styled.p`
  font-size: 3rem;
  color: var(--details-color);
`;
